import React from 'react'

function Footer() {
  return (
    <div className=' p-1 md:p-5 flex justify-center'>
    <p className='text-sm md:text-base'>Copyright &copy; 2024 by Mina Th.Jameel </p>
  </div>
  )
}

export default Footer
